import React from 'react';

// Balance line, split where it crosses zero (x 214) so the part below zero can be orange
const ABOVE_ZERO = 'M8 30 C 40 18, 70 26, 100 36 S 160 44, 185 60 S 205 78, 214 84';
const BELOW_ZERO = 'M214 84 C 224 91, 240 99, 260 103 S 285 108, 292 109';
const ZERO_Y = 84;

/**
 * Cash-flow forecast for the warning email: range tabs (30/45/90 days), the balance line
 * dipping below zero, and a marker with the date it goes negative.
 * @param {Object} props
 * @param {{ranges: string[], active: string, start: string, end: string, zero: string,
 *   marker: string}} props.chart - Texts from `features.<id>.email.chart`
 * @returns {JSX.Element} Chart
 */
function CashChart({ chart }) {
  return (
    <div className="email-chart" aria-hidden="true">
      <div className="email-chart-ranges">
        {chart.ranges.map((range) => (
          <span key={range} className={`email-chart-range${range === chart.active ? ' is-active' : ''}`}>
            {range}
          </span>
        ))}
      </div>
      <svg className="email-chart-svg" viewBox="0 0 300 126" focusable="false">
        <path className="email-chart-area" d={`${ABOVE_ZERO} L 8 ${ZERO_Y} Z`} />
        <path className="email-chart-area-below" d={`${BELOW_ZERO} L 292 ${ZERO_Y} Z`} />
        <line className="email-chart-zero" x1="8" y1={ZERO_Y} x2="292" y2={ZERO_Y} />
        <path className="email-chart-line" d={ABOVE_ZERO} />
        <path className="email-chart-line-below" d={BELOW_ZERO} />
        <circle className="email-chart-marker" cx="214" cy={ZERO_Y} r="4.5" />
        <text className="email-chart-marker-label" x="222" y="76" fontSize="11">
          {chart.marker}
        </text>
        <text className="email-chart-axis" x="10" y="79" fontSize="9">
          {chart.zero}
        </text>
        <text className="email-chart-axis" x="8" y="119" fontSize="10">
          {chart.start}
        </text>
        <text className="email-chart-axis" x="292" y="119" fontSize="10" textAnchor="end">
          {chart.end}
        </text>
      </svg>
    </div>
  );
}

export default CashChart;
